<template>
  <div>
    <div id="overlay" @click="closePopup()" style="position: fixed; width: 100%; height: 100%; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0); z-index: -1; cursor: pointer;"></div>
    <div class="absolute flex flex-col absolute justify-content rounded shadow-lg bg-grey-extralight z-20" style="left: 260px; top: 0px; width: max-content; max-width: 600px;">
      <div class="flex flex-row justify-between px-4 py-2 items-center border-solid border-b border-grey-lightest">
          <div class="font-semibold text-sm text-grey-dark py-2 mr-auto">Active Consultations</div>
          <img @click="closePopup()" class="flex flex-col w-5 h-5 cursor-pointer ml-8" src="../../assets/close.png">
      </div>
      <div class="flex flex-wrap p-4 items-top justify-center">
          <div v-if="loadDetails.length<1" class="flex text-sm text-grey-darkest my-4 items-center">No doctor is Active</div>
          <div v-for="(loadDetail, index) in loadDetails" :key="index" class="flex flex-col bg-grey-lightest rounded m-1 px-2 py-2 flex-no-shrink items-center flex-no-grow">
            <div class="text-xs my-1 font-semibold text-blue border border-solid border-blue flex flex-row rounded-full h-8 w-8 flex self-center items-center justify-center">
              {{loadDetail.count}}
            </div>
            <div class="flex text-xs font-semibold text-grey-darkest my-1 capitalize">
              {{loadDetail.doctor_name}}
            </div>
            <div v-if="loadDetail.patients && loadDetail.patients.length>0" class="flex flex-col text-xs text-grey-darker capitalize my-1 w-full items-center overflow-y-auto" style="max-height: 56px;">
              <div v-for="(patient, index) in loadDetail.patients" :key="index" class='' >
                <div class="mr-1">* {{patient}}</div>
              </div>
            </div>
          </div>
      </div>
      <!-- <div @click="closePopup()" style="position: fixed; display:flex; width: 100%; height: 100%; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0); z-index: 49;"></div> -->
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  computed: {
    ...mapState({
      loadDetails: state => state.consultationRequest.loadDetails
    })
  },
  methods: {
    closePopup: function () {
      this.$emit('closePopup', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Consultations/ActiveDoctorsCard.vue